import { useRef } from 'react';
export var useDepartmentsNavigation = function useDepartmentsNavigation() {
  var ref = useRef(null);
  return {
    ref
  };
};